
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import Progress_1 from '@/assets/images/progress_1.png'
import Progress_2 from '@/assets/images/progress_2.png'
import Progress_3 from '@/assets/images/progress_3.png'
import Progress_4 from '@/assets/images/progress_4.png'
import Progress_5 from '@/assets/images/progress_5.png'
import Progress_6 from '@/assets/images/progress_6.png'
import Progress_7 from '@/assets/images/progress_7.png'

@Component({
  name: 'my-progress',
  components: {},
})
export default class IndexView extends Vue {
  @Prop({ type: String, default: '1' }) type!: string
  @Prop({ type: Number, default: 0 }) active!: number

  srcs: any = {
    '1': Progress_1,
    '2': Progress_2,
    '3': Progress_3,
    '4': Progress_4,
    '5': Progress_5,
    '6': Progress_6,
    '7': Progress_7,
  }
  steps = ['身份认证', '资料填写', '绑定银行卡', '视频见证', '提交申请']
}
